import './PageHeader.scss';

import * as React from 'react';

import { ShareButton } from './ShareButton';
import { ProgressIndicator, VerticalDivider, CommandBar, ICommandBarItemProps, DefaultButton } from '@fluentui/react';
import { DocumentTitle } from './DocumentTitle';

export interface PageHeaderProps {
  title: string | JSX.Element;
  documentTitle?: string;
  isLoading?: boolean;
  actions?: { items: ICommandBarItemProps[]; type?: string };
  pivot?: JSX.Element;
  showShareButton?: boolean;
  style?: React.CSSProperties;
}

export class PageHeader extends React.Component<PageHeaderProps> {
  public render(): JSX.Element {
    return (
      <>
        {typeof this.props.title === 'string' && this.props.title && <DocumentTitle title={this.props.title} />}
        {typeof this.props.title !== 'string' && this.props.documentTitle && <DocumentTitle title={this.props.documentTitle} />}

        {this.props.isLoading && (
          <ProgressIndicator
            styles={{
              root: { position: 'absolute', top: 0, left: 0, width: '100%' },
              itemProgress: { padding: 0 },
            }}
          />
        )}
        <div style={this.props.style} className="pageheader flex flex-center">
          <div className="title flex flex-center" data-tid="txt_title">
            {this.props.title}
            {this.props.showShareButton && <ShareButton />}
            {this.renderPivot()}
          </div>
          <div className="actions flex flex-center">{this.renderActions()}</div>
        </div>
      </>
    );
  }

  private renderActions(): JSX.Element | null {
    const { actions } = this.props;
    if (!actions) {
      return null;
    }

    switch (actions.type) {
      case 'dropdown':
        return (
          <DefaultButton
            text="Actions"
            menuProps={{
              shouldFocusOnMount: true,
              items: actions.items,
            }}
          />
        );
      default:
        return <CommandBar className="actions" items={[]} farItems={actions.items || []} />;
    }
  }

  private renderPivot(): JSX.Element | null {
    if (!this.props.pivot) {
      return null;
    }
    return (
      <>
        <VerticalDivider styles={{ divider: { height: 40, marginRight: 10, marginLeft: 20 } }} />
        {this.props.pivot}
      </>
    );
  }
}
